<template>
  <div class="vertical items-center hub-wrap w-full">
    <div class="hub-name">iKrusher</div>
    <div class="hub-name">{{ hub.macAddress }}</div>
    <div class="device-bg">
      <van-image :src="require('@/assets/icons/v2/ic_hub_device.svg')"/>
    </div>

    <div class="disconnect-btn" v-if="hub.gatt.connected" @click="onConnect">Disconnected</div>
    <div class="connect-btn" v-else @click="onConnect">Connected</div>

  </div>
</template>

<script>
export default {
  name: "Hub",
  props: {
    hub: {
      type: Object,
      require: true
    }
  },
  methods: {
    onConnect() {
      this.$emit("onConnect");
    }
  },
  mounted() {
    console.log(this.hub.gatt);
  }
};
</script>

<style scoped lang="less">
.hub-wrap {
  border-radius: 12px;
  border: 1px solid #A4A4A4;
  background: white;
  font-size: 14px;
  padding: 16px;
}

.hub-name {
  font-size: 12px;
}

.device-bg {
  margin-top: 23px;
  background: #F0F5FF;
  border-radius: 50%;
  width: 96px;
  height: 96px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.connect-btn {
  text-align: center;
  width: 97px;
  height: 25px;
  margin-top: 20px;
  line-height: 25px;
  color: white;
  border-radius: 8px;
  font-weight: bold;
  background: #000000;
}

.disconnect-btn {
  text-align: center;
  width: 97px;
  height: 25px;
  margin-top: 20px;
  line-height: 25px;
  color: #333333;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  font-weight: bold;
  background: white;
}
</style>